export default {
    productionRequestUrl: "https://api.app.zb2.gr/v1",
    devRequestUrl: "https://devapi.app.zb2.gr/v1",
    tokenTypeBearer: false,
    API_KEY: "57uEfguijvOzEkauGGe9i49vXOsFWVx0H4hlbQ_Jgt_aEkzACf6zg8s2NQjYiHke",
    ID: "id",
    licenceID: "???",
    image_field_name: "imageUrl",
  };